export function median(numbers: number[]): number | undefined {
  return numbers.sort()[Math.floor(numbers.length / 2)];
}
